/**
 * @description: 团购套餐销售明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="gsr-ttxm-report">
        <div class="ttxm-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="ttxmTime">
                        <input type="text" class="form-control laydate-icon" v-model="ttxmStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="ttxmEndTime">
                    </div>
                </div>
                <label class="list-label-4">消费门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ttxm_shop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-4">包厢区域:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择包厢区域" v-model="ttxm_room_area" ref="ttxm_room_area" readonly @click="ttxmRoomAreaFun()">
                    <span class="selection-clear" @click="clear_input">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <label class="list-label-4">团购来源:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ttxm_from" data-placeholder="请选择团购来源"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-3">操作人:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ttxm_admin" data-placeholder="请选择操作人"></select>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitTtxmTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getTtxmExportSet">导出</button>
                </div>
            </div>
            <div class="row">
                <label class="list-label-6">销售数据合计:</label>
                <div class="list-total" ref="ttxm_xs_total"></div>
                <label class="list-label-6">团购总额合计:</label>
                <div class="list-total" ref="ttxm_tg_amount"></div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="ttxmList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="ttxmExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='ttxmExport_allcheck' @click='ttxmExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxmExport_checkModel' value="pay_time">
                            <label>支付时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxmExport_checkModel' value="order_id">
                            <label>订单编号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxmExport_checkModel' value="group_type_name">
                            <label>团购来源</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxmExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxmExport_checkModel' value="room_area_name">
                            <label>包厢区域</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxmExport_checkModel' value="room_name">
                            <label>包厢号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxmExport_checkModel' value="admin_name">
                            <label>操作人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxmExport_checkModel' value="package_name">
                            <label>团购套餐名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxmExport_checkModel' value="quantity">
                            <label>销售数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxmExport_checkModel' value="refund_quantity">
                            <label>退货数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxmExport_checkModel' value="price">
                            <label>团购单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxmExport_checkModel' value="settlemen_price">
                            <label>团购结算价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxmExport_checkModel' value="amount_total">
                            <label>团购总额</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='ttxmExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='ttxmExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 包厢区域弹窗 -->
            <div class="ele-hide" ref="ttxm_area_alert">
                <div class="sel-seldiv">
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='ttxm_area_allcheck' @click='ttxmAreaCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li v-for="item in ttxm_area_data" :key="item.id">
                            <input type="checkbox" v-model='ttxm_area_model' :value="item.id">
                            <label>{{item.name}}</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                ttxmStartTime: "",
                ttxmEndTime: "",
                ttxm_room_area: '',
                ttxm_area_allcheck: false,
                ttxm_c_area_allcheck: false,
                ttxm_area_model: [],
                ttxm_area_data: [],
                ttxmExport_allcheck: false,
                c_ttxmExport_allcheck: false,
                ttxmExport_checkModel: [],
                ttxmExport_checkData: ['pay_time', 'order_id', 'group_type_name', 'shop_name', 'room_area_name', 'room_name', 'admin_name', 'package_name', 'quantity', 'refund_quantity', 'price', 'settlemen_price', 'amount_total'],
                ttxmExport_type: 1,
            }
        },
        watch: {
            ttxm_room_area: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.ttxm_room_area).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.ttxm_room_area).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
            ttxm_area_model: {
                handler: function(val, oldVal) {
                    if(this.ttxm_area_model.length >= this.ttxm_area_data.length) {
                        this.ttxm_area_allcheck = true;
                        this.ttxm_c_area_allcheck = true;
                    } else {
                        this.ttxm_area_allcheck = false;
                        this.ttxm_c_area_allcheck = false;
                    }
                },
                deep: true
            },
            ttxmExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.ttxmExport_checkModel.length >= this.ttxmExport_checkData.length) {
                        this.ttxmExport_allcheck = true;
                        this.c_ttxmExport_allcheck = true;
                    } else {
                        this.ttxmExport_allcheck = false;
                        this.c_ttxmExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.ttxmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.ttxmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店
            // 团购来源
            $(this.$refs.ttxm_from).select2({
                minimumResultsForSearch: -1,
                language: "zh-CN",
                width: '100%'
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.ttxmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ttxmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.ttxmStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ttxmEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.ttxmTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.ttxmStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.ttxmEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.ttxm_shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                // 操作人
                                _this.getAdmin(e.params.data.id);
                                if(e.params.data.text == "全部") {
                                    $(_this.$refs.ttxm_room_area).val('').trigger('change');
                                    $(_this.$refs.ttxm_room_area).prop('disabled', true);
                                    return;
                                }
                                $(_this.$refs.ttxm_room_area).val('').trigger('change');
                                $(_this.$refs.ttxm_room_area).prop('disabled', false);
                                _this.getRoomArea(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id);
                                _this.getShopGroupType(e.params.data.id);
                            });
                            $(_this.$refs.ttxm_shop).val(data.response.result[1].id).trigger('change');
                            $(_this.$refs.ttxm_room_area).val('').trigger('change');
                            $(_this.$refs.ttxm_room_area).prop('disabled', false);
                            _this.getRoomArea($(_this.$refs.ttxm_shop).val());
                            // 操作人
                            _this.getAdmin($(_this.$refs.ttxm_shop).val());
                            _this.setShopDefaultTime($(_this.$refs.ttxm_shop).val());
                            _this.getShopGroupType($(_this.$refs.ttxm_shop).val());
                            _this.innitTtxmTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢区域
            getRoomArea: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getRoomArea",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.ttxm_area_data = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取操作人
            getAdmin: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result']['user_info'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.ttxm_admin).html("");
                            $(_this.$refs.ttxm_admin).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 清空多选
            clear_input: function() {
                this.ttxm_room_area = "";
                this.ttxm_area_model = [];
            },



            // 打开包厢区域
            ttxmRoomAreaFun: function() {
                let _this = this;
                let ttxm_c_area_model = _this.ttxm_area_model;
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['包厢区域', true],
                    area: ['300px', ''], // 宽高
                    content: $(_this.$refs.ttxm_area_alert),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.ttxm_room_area != "") {
                            _this.ttxm_area_model = ttxm_c_area_model;
                            return;
                        }
                        _this.ttxm_room_area = [];
                    }
                }, function() {
                    let areaTxts = [];
                    _this.ttxm_area_data.forEach(function(item) {
                        _this.ttxm_area_model.forEach(function(item2) {
                            if(item.id == item2) {
                                areaTxts.push(item.name);
                            }
                        });
                    });
                    _this.ttxm_room_area = areaTxts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.ttxm_room_area != "") {
                        _this.ttxm_area_model = ttxm_c_area_model;
                        return;
                    }
                    _this.ttxm_area_model = [];
                });
            },
            // 包厢区域全选
            ttxmAreaCheckedAll: function() {
                let _this = this;
                _this.ttxm_area_allcheck = _this.ttxm_c_area_allcheck;
                if(!_this.ttxm_area_allcheck) { // 实现全选
                    _this.ttxm_area_model = [];
                    _this.ttxm_area_data.forEach(function(item) {
                        _this.ttxm_area_model.push(item.id);
                    });
                } else { // 实现反选
                    _this.ttxm_area_model = [];
                }
            },
            // 获取团购来源类型
            getShopGroupType: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopGroup",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result']['result'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.ttxm_from).html("");
                            $(_this.$refs.ttxm_from).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 表格
            innitTtxmTable: function() {
                let _this = this;
                $(_this.$refs.ttxmList).bootstrapTable('destroy');
                $(_this.$refs.ttxmList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getTtxmList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "pay_time",
                        title: "支付时间",
                        width: "100",
                        valign: "middle"
                    }, {
                        field: "order_id",
                        title: "订单编号",
                        width: "110",
                        valign: "middle"
                    }, {
                        field: "group_type_name",
                        title: "团购来源",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "130",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "room_area_name",
                        title: "包厢区域",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "room_name",
                        title: "包厢号",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "package_name",
                        title: "团购套餐<br />名称",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "quantity",
                        title: "销售数量",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "refund_quantity",
                        title: "退货数量",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "price",
                        title: "团购单价",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "settlemen_price",
                        title: "团购<br/>结算价",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "amount_total",
                        title: "团购总额",
                        width: "6%",
                        valign: "middle"
                    }],
                });
            },
            getTtxmList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.ttxmStartTime,
                            "end_time": _this.ttxmEndTime,
                            "shop_id": $(_this.$refs.ttxm_shop).val(),
                            "room_areas": _this.ttxm_area_model,
                            "group_type": $.trim($(_this.$refs.ttxm_from).val()),
                            "admin_id": $.trim($(_this.$refs.ttxm_admin).val())
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + 'FinanceReport2/getGroupPackageSaledList',
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                            $(_this.$refs.ttxm_xs_total).text(data.response.result.quantity_total);
                            $(_this.$refs.ttxm_tg_amount).text(data.response.result.amount_total);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getTtxmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/groupSaledExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.ttxmExport_checkModel = data.response.result.export_fields;
                                _this.ttxmExport_type = data.response.result.export_type;
                            } else {
                                _this.ttxmExport_checkModel = _this.ttxmExport_checkData;
                                _this.ttxmExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.ttxmExport_alert)
                }, function() {
                    _this.exportTtxmList();
                });
            },
            // 导出字段全选
            ttxmExportCheckedAll: function(type) {
                let _this = this;
                _this.ttxmExport_allcheck = _this.c_ttxmExport_allcheck;
                if(!_this.ttxmExport_allcheck) { // 实现全选
                    _this.ttxmExport_checkModel = [];
                    _this.ttxmExport_checkData.forEach(function(item) {
                        _this.ttxmExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.ttxmExport_checkModel = [];
                }
            },
            // 点击“导出”按钮
            exportTtxmList: function() {
                let _this = this;

                let export_fields = JSON.stringify(_this.ttxmExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport2/groupSaledExport" +
                    "?start_time=" + _this.ttxmStartTime +
                    "&end_time=" + _this.ttxmEndTime +
                    "&shop_id=" + $(_this.$refs.ttxm_shop).val() +
                    "&room_areas=" + _this.ttxm_area_model +
                    "&group_type=" + $.trim($(_this.$refs.ttxm_from).val()) +
                    "&admin_id=" + $.trim($(_this.$refs.ttxm_admin).val()) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.ttxmExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .ttxm-list {
        .fixed-table-body {
            overflow-x: scroll;
            table {
                width: 1300px;
                // table-layout: fixed;
                word-wrap: break-word;
            }
        }
        .fixed-table-body::-webkit-scrollbar {
            position: absolute;
            top: 0;
            left: 0;
            height: 30px;
        }
    }
</style>